// FNP-117: real account deletion. Calls the FNP-285 deleteAccount mutation
// which flips the account row to PENDING_DELETION and emits the EventBridge
// event the workflows-api playbook consumes (FNP-360 / FNP-361). The form
// then renders a confirmation panel showing the 30-day recovery window
// before signing the user out.
import {
    Box,
    Card,
    Container,
    Grid,
    Stack,
    Text
} from "@mantine/core";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {DeleteAccountForm} from "../forms/DeleteAccountForm.tsx";
import {AiOutlineWarning} from "react-icons/ai";
import {DeleteAccountPageNavigation} from "../navigation/DeleteAccountPageNavigation";


export const DeleteAccountPage = () => {
    return (
        <FormPageLayout
            title="Delete Account"
            pageNavigation={<DeleteAccountPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <Container>
                    <Stack gap={'xl'}>
                        <Card shadow={'sm'}>
                            <Grid>
                                <Grid.Col span={1}>
                                    <AiOutlineWarning size={'3em'} color={'orange'}/>
                                </Grid.Col>
                                <Grid.Col span={11}>
                                    <Box>
                                        <Text>
                                            Deleting your account marks it for permanent removal.
                                            You will have <strong>30 days</strong> to recover it by
                                            contacting support; after that, all account data is
                                            permanently deleted.
                                        </Text>
                                    </Box>
                                </Grid.Col>
                            </Grid>
                        </Card>

                        <Box my={'xl'}>
                            <DeleteAccountForm/>
                        </Box>
                    </Stack>
                </Container>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
